import { render, staticRenderFns } from "./TabsWithRoutes.vue?vue&type=template&id=f58bb49c"
import script from "./TabsWithRoutes.vue?vue&type=script&lang=ts"
export * from "./TabsWithRoutes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58bb49c')) {
      api.createRecord('f58bb49c', component.options)
    } else {
      api.reload('f58bb49c', component.options)
    }
    module.hot.accept("./TabsWithRoutes.vue?vue&type=template&id=f58bb49c", function () {
      api.rerender('f58bb49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabsWithRoutes.vue"
export default component.exports